import React from "react";

export const HealthCheck = () => {
    return (
        <div>
            <div>Status is good</div>
        </div>)
}